<mat-horizontal-stepper linear #stepper class="add-new-lead-stepper">

  <mat-step>
    <div>
      <div class="tw-py-4 tw-grid tw-grid-flow-col tw-justify-between tw-place-items-center" *ngIf="!callWrapUp">
          <h2 class="new-business-heading" *ngIf="!addNewLeadFromSource;else newLeadFromSource">Add New Business</h2>
          <ng-template #newLeadFromSource>
            <h2 class="new-business-heading">Add New Lead Source for {{ duplicateUser.id }}</h2>
          </ng-template>
        <button mat-icon-button mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>

        <app-alert *ngIf="activationCodeMessage"
          [message]="activationCodeMessage"
          level="warning"
          (dismissed)="newBusinessAlertDismissed.emit()">
        </app-alert>

        <app-alert *ngIf="activationCodeSuccessMessage"
          [message]="activationCodeSuccessMessage"
          level="success"
          (dismissed)="newBusinessAlertDismissed.emit()">
        </app-alert>

        <app-alert *ngIf="noLeadDataFound"
          [message]="noLeadDataFound"
          level="warning"
          (dismissed)="newBusinessAlertDismissed.emit()">
        </app-alert>

      <div *ngIf="activeUserAccount.borrowerId"
           class="new-business-alert new-business-alert-warning tw-leading-6"
           role="new-business-alert">
        <mat-icon class="tw-float-left">warning</mat-icon>
        <span class="tw-px-2">{{ activeUserAccount.message }}</span>
        <a (click)="showActivateUser()" mat-dialog-close>Find it here</a>
        <button type="button" mat-dialog-close class="tw-float-right">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form [formGroup]="addBusinessForm" class="add-new-lead-form">
          <formly-form [options]='formOptions' [form]="addBusinessForm" [fields]="fields" [model]="model"></formly-form>
          <span><strong>* = Required fields</strong></span>

          <div *ngIf="(duplicatePhoneNumber || duplicateEmail)">
            <div class="duplicate-user">
              <div class="duplicate-user-heading"><p class="duplicate-style">This is duplicate user</p></div>
              <div class="duplicate-user-info">
                <p>{{ duplicateUser.name }}</p>
                <p>{{ duplicateUser.email }}</p>
                <p>{{ duplicateUser.phone }}</p>
              </div>
            </div>
            <div class="skip-links">
              <div><a style="color: #0dc2ee; cursor: pointer;" (click)="viewDuplicateBorrower()" mat-dialog-close>Skip and go to Borrower page</a></div>
              <div><a style="color: #0dc2ee; cursor: pointer;" (click)="updateExistingBorrower()">Add New Lead Source for Borrower</a></div>
            </div>
          </div>

          <div *ngIf="isFranchise" class="bulk-import">
            <div>Want to do a bulk import of your businesses from a spreadsheet? Use our
              <a mat-dialog-close routerLink="/import">Bulk Import Tool</a>.
            </div>
          </div>

          <mat-dialog-actions align="end">
              <button mat-button mat-dialog-close>Cancel</button>
              <button
                color="primary"
                mat-raised-button
                matStepperNext
                data-cy="continueNewLead"
                *ngIf="!(model.leadSource === 'Client Referral')"
                [disabled]="!addBusinessForm.valid" type="submit">
                Continue
              </button>
              <button color="primary" mat-raised-button *ngIf="(model.leadSource === 'Client Referral')" data-cy=submitReferralLead
                [disabled]="!addBusinessForm.valid || (loading$ | async)" type="submit" (click)="saveReferralLead()">
                <span *ngIf="!(loading$ | async)">Save Referral</span>
                <mat-spinner
                  diameter="24"
                  style="display: inline-block; height: 24px; width: 24px"
                  *ngIf="(loading$ | async)">
                </mat-spinner>
              </button>
            </mat-dialog-actions>
      </form>
    </div>
  </mat-step>

  <mat-step>
    <app-add-more-info-lead-form
      (saveData)="saveNewLead($event)"
      [loading$]="loading$"
      [duplicateLead$]="duplicateLead$"
      [showErrorMessage$]="showErrorMessage$"
      [errMessage]="errMessage">
    </app-add-more-info-lead-form>
  </mat-step>

</mat-horizontal-stepper>

